// getters
const inventoryProductsCategories = state => state.inventoryProductsCategories

export default {
  inventoryProductsCategories
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/categories/getters.js